import { useTranslation } from 'react-i18next';
import { ScrollText } from 'lucide-react';
import LegalDocument from './LegalDocument';
import { getLegalDoc } from '../../content/legal-content';
import { formatLegalDate } from './legal-language';
import './Legal.css';

export default function TermsPage() {
  const { t, i18n } = useTranslation();
  const updated = getLegalDoc(i18n.language, 'terms').updated;

  return (
    <div className="legal-page">
      <div className="legal-hero-banner">
        <div className="legal-hero-banner-icon"><ScrollText size={48} /></div>
        <div className="legal-hero-banner-content">
          <h1 className="legal-hero-banner-title">{t('legal.termsTitle')}</h1>
          <p className="legal-hero-banner-subtitle">{t('legal.subtitle')}</p>
        </div>
      </div>

      <p className="legal-last-updated">{t('legal.lastUpdated')}: {formatLegalDate(updated, i18n.language)}</p>

      <LegalDocument lang={i18n.language} kind="terms" />
    </div>
  );
}
